import React from 'react';

import styles from './AddonPicker.module.less';
import AbstractPicker, { connect } from '../AbstractPicker';
import { translate } from '../../../services/L10n';
import { Icon } from '../../Icon';
import Tooltip from '../../Popup/Tooltip';
import { TOP } from '../../Popup/alignments';
import classnames from 'classnames';
import { t } from '../../../translations';

class AddonPicker extends AbstractPicker {
  constructor(props) {
    super(props);

    this.state = { enabled: !!props.selected };
    this.onClick = this.onClick.bind(this);
    this.addableItem = props.items && props.items[0];
  }

  icons = {
    cover: {
      iconName: 'CoverIcon',
      tooltip: {
        enabled: translate(t.TOOLTIP_REMOVE_COVER),
        disabled: translate(t.TOOLTIP_ADD_COVER),
      },
    },
  };

  onClick() {
    const { parent, slot, addonType } = this.props;

    !this.state.enabled
      ? this.add(parent, slot, this.addableItem)
      : this.removeChildren(parent, addonType);
    this.setState({ enabled: !this.state.enabled });
  }

  render() {
    const { addonType } = this.props;
    return (
      <Tooltip
        alignment={TOP}
        spacing={2}
        ignorePadding={true}
        content={
          this.state.enabled
            ? this.icons[addonType].tooltip.enabled
            : this.icons[addonType].tooltip.disabled
        }
      >
        <div className={styles.wrapper} onClick={this.onClick}>
          <Icon
            className={classnames(this.state.enabled && styles.enabled)}
            iconName={this.icons[addonType].iconName}
          />
        </div>
      </Tooltip>
    );
  }
}

export default connect(AddonPicker);
